import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Switch, withRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Dashboard from 'scenes/Dashboard';
import Domain from 'scenes/Domain';
import Analytics from 'scenes/Analytics';
import DomainPage from 'scenes/DomainPage';
import Landing from 'landing/Landing';
import SignIn from 'scenes/SignIn';
import SignUp from 'scenes/SignUp';
import Contact from 'scenes/Contact';
import FaqPage from 'scenes/Faq';
import Thanks from 'scenes/Thanks';
import Profile from 'scenes/Profile';
import Billing from 'scenes/Billing';
import Privacy from 'scenes/Privacy';
import EditPassword from 'scenes/EditPassword';
import RequireAuth from 'helpers/RequireAuth';
import RequireNothing from 'helpers/RequireNothing';
import RequireNotAuth from 'helpers/RequireNotAuth';
import RequireSubscription from 'helpers/RequireSubscription';
import RequireAuthNotSubscribed from 'helpers/RequireAuthNotSubscribed';
import setLang from 'store/modules/langs/actions';

import Modals from 'components/Modals';

import {
  DASHBOARD_PATH,
  DOMAIN_PATH,
  DOMAIN_PAGE_PATH,
  ANALITICS_PAGE_PATH,
  HOME_PATH,
  SIGN_IN_PATH,
  SIGN_UP_PATH,
  CONTACT_PATH,
  PROFILE_PATH,
  AFFILIATE_PATH,
  THANK_YOU_PATH,
  FAQ_PATH,
  BILLING_PATH,
  PRIVACY_PATH,
  EDIT_PASSWORD_PATH,
} from 'routes';

class Main extends Component {
  componentWillMount() {
    const { currentLang, setLang } = this.props;

    if (currentLang !== 'en') {
      setLang('en');
    }
  }

  render() {
    return (
      <div className="out-content">
        <Switch>
          <RequireNothing
            exact
            path={HOME_PATH}
            component={Landing}
            props={this.props}
          />
          <RequireNotAuth
            path={SIGN_IN_PATH}
            component={SignIn}
            props={this.props}
          />
          <RequireNotAuth
            path={SIGN_UP_PATH}
            component={SignUp}
            props={this.props}
          />
          <RequireSubscription
            path={DOMAIN_PAGE_PATH + '/:id'}
            component={DomainPage}
            props={this.props}
          />
          <RequireSubscription
            path={DOMAIN_PATH}
            component={Domain}
            props={this.props}
          />
          <RequireNothing
            path={CONTACT_PATH}
            component={Contact}
            props={this.props}
          />
          <RequireSubscription
            path={PROFILE_PATH}
            component={Profile}
            props={this.props}
          />
          <RequireSubscription
            path={THANK_YOU_PATH}
            component={Thanks}
            props={this.props}
          />
          <RequireNothing
            path={FAQ_PATH}
            component={FaqPage}
            props={this.props}
          />
          <RequireNothing
            path={PRIVACY_PATH}
            component={Privacy}
            props={this.props}
          />
          <RequireAuth
            path={BILLING_PATH}
            component={Billing}
            props={this.props}
          />
          <RequireNotAuth
            exact
            path={EDIT_PASSWORD_PATH}
            component={EditPassword}
            props={this.props}
          />
        </Switch>
        <ToastContainer />
        <Modals i18n={this.props.i18n} />
      </div>
    );
  }
}

const mapDispatchToProps = {
  setLang,
};

const mapStateToProps = state => ({
  isLoggedIn: state.auth.isUserLoggedIn,
  token: state.auth.token,
  user: state.details.user,
  currentLang: state.langs.currentLang,
  i18n: state.langs.i18n,
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Main),
);



// WEBPACK FOOTER //
// ./src/scenes/Main/Main.js